import {Component, EventEmitter, Input, Output} from '@angular/core';
import {TongueDiagnosisDto} from "../../../model/dto";

@Component({
  selector: 'app-diagnosis-displayer',
  templateUrl: './diagnosis-displayer.component.html',
  styleUrls: ['./diagnosis-displayer.component.scss']
})
export class DiagnosisDisplayerComponent {
  @Input() results: TongueDiagnosisDto[];
  @Input() imageUrl: string;
  @Output() close: EventEmitter<void> = new EventEmitter<void>();

  closeDiagnosisDisplayer(): void {
    this.close.emit();
  }
}
